import React, { useState } from 'react';
import { showError, showSuccess } from 'utils';
import ActionButton from 'components/ActionButton';
import CommonModal from 'components/CommonModal';
import styles from './index.module.scss';
import SalesChannelDropwdown from 'components/SalesChannelsDropdown';
import { copyCatalogFromSalesChannel } from 'services/api/salesChannel';
import { Error } from 'components/message/Error';

const CopyCatalogue = (props) => {
  const { salesChannelId } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const [isCopyCatalogueModaOpen, setIsCopyCatalogueModaOpen] = useState(false);
  const [sourceSalesChannel, setSourceSalesChannel] = useState(salesChannelId);
  const [destSalesChannel, setDestSalesChannel] = useState();
  const [errors, setErrors] = useState({}) as any;

  const toggleModal = () => {
    setIsCopyCatalogueModaOpen(!isCopyCatalogueModaOpen);
  };

  const validateForm = () => {
    const errorsTemp = {} as any;
    if (!sourceSalesChannel) {
      errorsTemp.sourceSalesChannel = 'Please select source sales channel';
    }
    if (!destSalesChannel) {
      errorsTemp.destSalesChannel = 'Please select destination sales channel';
    }
    setErrors(errorsTemp);
    return Object.keys(errorsTemp)?.length;
  };

  const onClickAdd = async () => {
    const isFormInValid = validateForm();
    if (isFormInValid) {
      return;
    }
    try {
      setLoading(true);
      const res = await copyCatalogFromSalesChannel({
        fromSalesChannelId: sourceSalesChannel,
        toSalesChannelId: destSalesChannel,
      });
      showSuccess('Catalogue copied successfully');
      toggleModal()
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <ActionButton
        text={'Copy Catalogue'}
        active={true}
        isLoading={false}
        onClick={toggleModal}
        customClass={'mt-2'}
      />
      {isCopyCatalogueModaOpen && (
        <CommonModal
          title='Please select sales channels'
          cancellable={true}
          toggleModal={toggleModal}
          primaryButtonText='Save'
          primaryButtonOnClick={onClickAdd}
          secondaryButtonText='Cancel'
          secondaryButtonOnClick={toggleModal}
        >
          <div style={{ width: '100%' }} className={`d-flex`}>
            <div
              style={{ flex: 1, width: '50%' }}
              className={`mr-2 ${styles['input-group']}`}
            >
              <div className={styles['label']}>Source Sales Channel</div>
              <SalesChannelDropwdown
                title='Source Sales Channel'
                value={sourceSalesChannel}
                onChange={setSourceSalesChannel}
              />
              {errors?.sourceSalesChannel ? (
                <Error message={errors?.sourceSalesChannel} />
              ) : null}
            </div>

            <div
              style={{ flex: 1, width: '50%' }}
              className={`ml-2 ${styles['input-group']}`}
            >
              <div className={styles['label']}>Destination Sales Channel</div>
              <SalesChannelDropwdown
                title='Destination Sales Channel'
                value={destSalesChannel}
                onChange={setDestSalesChannel}
              />
              {errors?.destSalesChannel ? (
                <Error message={errors?.destSalesChannel} />
              ) : null}
            </div>
          </div>
        </CommonModal>
      )}
    </div>
  );
};

export default CopyCatalogue;
